"use strict";

export class AudioTrack {
    constructor(config) {
        this.name = config.name;
        this.loop = config.loop === undefined ? false : config.loop;
        this.volume = config.volume === undefined ? 1 : config.volume;
        this.track = PIXI.sound.find(this.name);

        this.track.volume = this.volume;
        this.track.loop = this.loop;

        this.muted = config.muted === undefined ? false : config.muted;
        this.track.muted = this.muted;
        
        this.fadeDelta = 0;
        this.fadeCoroutine = null;

        if (config.autoplay) {
            this.play();
        }
    }

    play(onEnded) {
        if (this.track.paused) {
            this.track.resume();
        } else {
            if (onEnded !== undefined) {
                this.track.play().on("end", onEnded);
            } else {
                this.track.play();
            }
        }
    }

    pause() {
        this.track.pause();
    }

    stop(fade) {
        if (fade) {
            this.fadeCoroutine = Coroutine.start(new Coroutine(this._fadeUpdate()));
        } else {
            this.track.stop();
        }
    }
    *_fadeUpdate() {
        this.fadeDelta = 1 - this.volume;
        while (this.fadeDelta < 1) {
            this.fadeDelta = Math.min(1, this.fadeDelta + Time.deltaTime * 5);
            this.track.volume = 1 - this.fadeDelta;
            yield null;
        }

        this.track.stop();
        this.setVolume(this.volume);
        this.fadeCoroutine = null;
    }

    setVolume(volume) {
        this.volume = volume;
        this.track.volume = volume;
    }

    setMute(mute) {
        if (mute === undefined) {
            mute = !this.muted;
        }

        this.muted = mute;
        this.track.muted = this.muted;
    }

    isPlaying() {
        return this.track.isPlaying;
    }

    changeTrack(name) {
        if (this.track.isPlaying) {
            this.stop();
        }

        this.name = name;
        this.track = PIXI.sound.find(name);
        this.track.volume = this.volume;
        this.track.loop = this.loop;
        this.track.muted = this.muted;
    }
}